import { useTheme } from '@emotion/react';
import ArrowRight from '~/icons/iconography/arrow/right.svg';
import { UmbracoTypes } from '~/lib/data-contract';
import { UmbracoImage } from '~/shared/components/Image';
import { VisuallyHidden } from '~/shared/components/VisuallyHidden';
import { weakKey } from '~/shared/utils/jsx';
import { ModuleContainer } from '~/templates/blocks/shared/ModuleContainer';
import { queries } from '~/theme';
import { useModule } from '../../hooks/useModule';
import {
    StyledAction,
    StyledCategories,
    StyledCategory,
    StyledImageContainer,
    StyledLink,
} from './styled';

export type M21ReferencedCategoriesProps = UmbracoTypes.IM21ReferencedCategoriesModule;

/**
 * List of page references, extracts data from references field in CMS.
 * The layout is supposed to be used with presentational images and text which describes the page.
 */
export const M21ReferencedCategories = ({ items, ...rest }: M21ReferencedCategoriesProps) => {
    const { index } = useModule();
    const { sizes } = useTheme();

    const columnCount = Math.min(items?.length || 0, 5);
    const imagesVW = 100 / columnCount;
    const imagesMaxWidth = sizes.contentMaxWidth / columnCount;

    return (
        <ModuleContainer hasGutter {...rest}>
            <StyledCategories>
                {items?.map((item) => (
                    <StyledCategory key={weakKey(item)}>
                        {item.pageImage?.src ? (
                            <StyledImageContainer>
                                <UmbracoImage
                                    src={item.pageImage.src}
                                    alt={item.pageImage.name ?? ''}
                                    focalPoint={item.pageImage.focalPoint}
                                    fill
                                    style={{ objectFit: 'cover' }}
                                    sizes={`${queries.xs} 50vw, ${queries.contentMax} ${imagesVW}vw,  ${imagesMaxWidth}px`}
                                    priority={index < 2}
                                />
                            </StyledImageContainer>
                        ) : null}

                        {item.callToAction?.url ? (
                            <>
                                <StyledLink href={item.callToAction.url} {...item.callToAction}>
                                    <VisuallyHidden>{item.pageTitle}</VisuallyHidden>
                                </StyledLink>
                                <StyledAction>
                                    {item.pageTitle} <ArrowRight />
                                </StyledAction>
                            </>
                        ) : null}
                    </StyledCategory>
                ))}
            </StyledCategories>
        </ModuleContainer>
    );
};
